import React, { useState } from 'react';
import { Input, SpaceBetween } from "@cloudscape-design/components";

interface TextInputProps {
    label?: string;
    value: string;
    onChange: (value: string) => void;
    type?: 'text' | 'password' | 'email' | 'number';
    placeholder?: string;
    showMessage?: boolean;
    disabled?: boolean;
    message?: string;
    showPasswordToggle?: boolean;
}


export const TextInput: React.FC<TextInputProps> = ({
    label,
    value,
    onChange,
    type = "text",
    placeholder,
    showMessage = false,
    disabled = false,
    message,
    showPasswordToggle = false,
}) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    const handleChange = (event: { detail: { value: string } }) => {
        onChange(event.detail.value);
    };

     const defaultMessage = `${placeholder} value can't be empty`;
     const displayMessage = message || defaultMessage;

     const resolvedType = (type === 'password' && passwordVisible) ? 'text' : type;

    return (
        <SpaceBetween size='m' direction='vertical'>
            <SpaceBetween size='m' direction='horizontal'>
                <div>{label}</div>
            </SpaceBetween>
            <div style={{ position: 'relative' }}>
                <Input 
                    onChange={handleChange}
                    value={value}
                    type={resolvedType}
                    placeholder={placeholder}
                    disabled={disabled}
                />
                {showPasswordToggle && type === 'password' && (
                    <button
                        type="button"
                        onClick={() => setPasswordVisible(prev => !prev)}
                        aria-label={passwordVisible ? 'Hide password' : 'Show password'}
                        style={{
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            color: '#545b64',
                        }}
                    >
                        {passwordVisible ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                <circle cx="12" cy="12" r="3" />
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                                <line x1="1" y1="1" x2="23" y2="23" />
                            </svg>
                        )}
                    </button>
                )}
            </div>
            {showMessage && <p className='tip-text'>{displayMessage}</p>}
        </SpaceBetween>
    )
    
}